import { Controller } from "@hotwired/stimulus";

// Minimal drag-to-sort using native HTML5 DnD
export default class extends Controller {
  static values = { productId: Number };

  connect() {
    this.items = Array.from(this.element.querySelectorAll(".photo-item"));
    this.items.forEach((li) => {
      li.setAttribute("draggable", "true");
      li.addEventListener("dragstart", this.onDragStart);
      li.addEventListener("dragover", this.onDragOver);
      li.addEventListener("drop", this.onDrop);
    });
  }

  disconnect() {
    this.items?.forEach((li) => {
      li.removeEventListener("dragstart", this.onDragStart);
      li.removeEventListener("dragover", this.onDragOver);
      li.removeEventListener("drop", this.onDrop);
    });
  }

  onDragStart = (e) => {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", e.currentTarget.dataset.id);
  };

  onDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  onDrop = (e) => {
    e.preventDefault();
    const draggedId = e.dataTransfer.getData("text/plain");
    const target = e.currentTarget;
    const list = this.element;

    const draggedEl = list.querySelector(`[data-id="${draggedId}"]`);
    if (!draggedEl || draggedEl === target) return;

    // Insert before target
    list.insertBefore(draggedEl, target);

    // Persist new order
    const order = Array.from(list.querySelectorAll(".photo-item")).map((li) => li.dataset.id);
    this.save(order);
  };

  async save(order) {
    const url = `/products/${this.productIdValue}/photos/reorder`;
    await fetch(url, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": this.#csrfToken() },
      body: JSON.stringify({ order }),
    });
    // Optional: flash/notification
  }

  #csrfToken() {
    const el = document.querySelector('meta[name="csrf-token"]');
    return el && el.content;
  }
}
